import { useState } from 'react'
import { RunWithDetails } from '../../types'
import { SegmentsTable } from './SegmentsTable'
import { AidStationsTable } from './AidStationsTable'
import { AddSegmentDialog } from './AddSegmentDialog'
import { AddAidStationDialog } from './AddAidStationDialog'
import { GpxImportDialog } from './GpxImportDialog'
import { useSegments } from '../../hooks/useSegments'
import { Button } from '../ui/button'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs'
import { Plus, Upload, Route, MapPin } from 'lucide-react'

interface CourseTabProps {
  run: RunWithDetails
}

export function CourseTab({ run }: CourseTabProps) {
  const [showAddSegmentDialog, setShowAddSegmentDialog] = useState(false)
  const [showAddAidStationDialog, setShowAddAidStationDialog] = useState(false)
  const [showGpxImportDialog, setShowGpxImportDialog] = useState(false)
  
  const { data: segments = [] } = useSegments(run.id)

  return (
    <div className="p-6 space-y-6">
      <Tabs defaultValue="segments" className="space-y-6">
        <div className="border-b border-neutral-200">
          <TabsList className="bg-transparent h-auto p-0 justify-start">
            <TabsTrigger
              value="segments"
              className="flex items-center gap-2 border-b-2 border-transparent data-[state=active]:border-primary-700 data-[state=active]:bg-transparent data-[state=active]:text-primary-700 rounded-none px-4 py-3 font-medium hover:bg-neutral-50"
            >
              <Route className="h-4 w-4" />
              Segments
            </TabsTrigger>
            <TabsTrigger
              value="aid-stations"
              className="flex items-center gap-2 border-b-2 border-transparent data-[state=active]:border-primary-700 data-[state=active]:bg-transparent data-[state=active]:text-primary-700 rounded-none px-4 py-3 font-medium hover:bg-neutral-50"
            >
              <MapPin className="h-4 w-4" />
              Aid Stations
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="segments" className="space-y-6">
          <div className="flex justify-between items-center">
            <h3 className="text-xl font-bold text-primary-900">Course Segments</h3>
            <div className="flex gap-3">
              <Button
                variant="outline"
                onClick={() => setShowGpxImportDialog(true)}
              >
                <Upload className="h-4 w-4 mr-2" />
                Import GPX
              </Button>
              <Button onClick={() => setShowAddSegmentDialog(true)}>
                <Plus className="h-4 w-4 mr-2" />
                Add Segment
              </Button>
            </div>
          </div>
          <SegmentsTable runId={run.id} />
        </TabsContent>

        <TabsContent value="aid-stations" className="space-y-6">
          <div className="flex justify-between items-center">
            <h3 className="text-xl font-bold text-primary-900">Aid Stations</h3>
            <Button onClick={() => setShowAddAidStationDialog(true)}>
              <Plus className="h-4 w-4 mr-2" />
              Add Aid Station
            </Button>
          </div>
          <AidStationsTable runId={run.id} />
        </TabsContent>
      </Tabs>

      <AddSegmentDialog
        runId={run.id}
        open={showAddSegmentDialog}
        onOpenChange={setShowAddSegmentDialog}
      />

      <GpxImportDialog
        runId={run.id}
        open={showGpxImportDialog}
        onOpenChange={setShowGpxImportDialog}
        existingSegments={segments}
      />

      <AddAidStationDialog
        runId={run.id}
        open={showAddAidStationDialog}
        onOpenChange={setShowAddAidStationDialog}
      />
    </div>
  )
}